import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MLStoresField from './ml-stores-field/ml-stores-field.component';
import CountingNumberField from '../fields/counting-number-field/counting-number-field.component';

const MLConfigurationForm = () => {
  const { t } = useTranslation();

  return (
    <Box className="field-container">
      <Typography variant="h6">
        {t('page.menus.recommendations.settings.locations.title')}
      </Typography>

      <MLStoresField />
      <Typography variant="h6" mt={2}>
        {t('page.menus.recommendations.settings.maxCountInput.title')}
      </Typography>
      <CountingNumberField
        name="maxRecommendations"
        data-testid="MaxRecommendations.IncTextField"
        label={t('page.menus.recommendations.settings.maxCountInput.label')}
        helperText={t(
          'page.menus.recommendations.settings.maxCountInput.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'MaxRecommendations.HelperText',
        }}
      />
      <Typography variant="h6" mt={2}>
        {t('page.menus.recommendations.settings.maxRuleRecommendations.title')}
      </Typography>
      <CountingNumberField
        name="maxRuleRecommendations"
        data-testid="MaxRuleRecommendations.IncTextField"
        label={t(
          'page.menus.recommendations.settings.maxRuleRecommendations.label',
        )}
        helperText={t(
          'page.menus.recommendations.settings.maxRuleRecommendations.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'MaxRuleRecommendations.HelperText',
        }}
      />
      <CountingNumberField
        name="mainCount"
        data-testid="MainCount.IncTextField"
        label={t('page.menus.recommendations.settings.mainCountInput.label')}
        helperText={t(
          'page.menus.recommendations.settings.mainCountInput.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'MainCount.HelperText',
        }}
      />
      <CountingNumberField
        name="sideCount"
        data-testid="SideCount.IncTextField"
        label={t('page.menus.recommendations.settings.sideCountInput.label')}
        helperText={t(
          'page.menus.recommendations.settings.sideCountInput.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'SideCount.HelperText',
        }}
      />
      <CountingNumberField
        name="beverageCount"
        data-testid="BeverageCount.IncTextField"
        label={t(
          'page.menus.recommendations.settings.beverageCountInput.label',
        )}
        helperText={t(
          'page.menus.recommendations.settings.beverageCountInput.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'BeverageCount.HelperText',
        }}
      />
      <CountingNumberField
        name="dessertCount"
        data-testid="DessertCount.IncTextField"
        label={t('page.menus.recommendations.settings.dessertCountInput.label')}
        helperText={t(
          'page.menus.recommendations.settings.dessertCountInput.helperText',
        )}
        IncFormHelperTextProps={{
          'data-testid': 'DessertCount.HelperText',
        }}
      />
    </Box>
  );
};

export default MLConfigurationForm;
